import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Ana projedeki DmndHttpClientService deseninin prototip karşılığı.
// Migrate ederken shared-services'teki DmndHttpClientService kullanılır.
@Injectable({ providedIn: 'root' })
export class ApiService {

  baseUrl = '';

  constructor(private http: HttpClient) {
    // API adresi, uygulamanın SERVİS EDİLDİĞİ host'a göre seçilir — build config'inden
    // (dev/prod) BAĞIMSIZ. Yalnızca localhost'ta çalışırken yerel API'ye gidilir;
    // gerçek bir alan adından (deploy) meta tag'deki prod adresi kullanılır.
    // Böylece hangi config'le build alınırsa alınsın yayında adres bozulmaz.
    const meta = document.querySelector('meta[name="base-url"]');
    const metaUrl = (meta ? meta.getAttribute('content') || '' : '').trim();
    const host = location.hostname;
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    const base = isLocal ? 'http://localhost:5001' : (metaUrl || 'http://localhost:5001');
    this.baseUrl = base.replace(/\/+$/, '') + '/';
  }

  PostData(servicePath: string, prms: any, callback: Function, onError?: Function) {
    this.http.post(this.baseUrl + servicePath, prms)
      .subscribe({
        next: res => callback(res),
        error: err => {
          console.log('Error occured', err);
          if (onError) onError(err);
        }
      });
  }
}
